module.exports = __webpack_public_path__ + "static/media/manonchair.78fd90a4.svg";